export default __webpack_public_path__ + "assets/images/turtle-red-fd795bf68db478464a640f7933065c0f.svg";